module.exports = __webpack_public_path__ + "img/9788954429924.f874effa.jpg";